// userLocationRetrieve.js
import { notification } from "antd";
import { notificationFlags } from "../constants"; // Import the flags

const userLocationRetrieve = async () => {
    // Check if geolocation is available in the browser
    if ("geolocation" in navigator) {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    (position) => resolve(position),
                    (error) => {
                        // console.log("navigationError", error)
                        // Handle POSITION_UNAVAILABLE (code 2)
                        // if (error?.code === 2) {
                        //     if (!notificationFlags.noInternet) {
                        //         notification.error({
                        //             message: 'No internet connection',
                        //             key: 'no-internet-connection',
                        //             duration: 3, // Auto-close after 3 seconds
                        //             onClose: () => {
                        //                 notificationFlags.noInternet = false;
                        //             },
                        //         });
                        //         notificationFlags.noInternet = true;
                        //     }
                        // }
                        // Handle other errors
                        reject(error);
                    }
                );
            });

            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            return { latitude, longitude };
        }
        catch (error) {
            // Handle PERMISSION_DENIED (code 1)
            if (error.code === 1) { // PERMISSION_DENIED
                if (!notificationFlags.enableLocation) {
                    notification.warning({
                        message: 'Please enable location',
                        key: 'enable-location',
                        duration: 3, // Auto-close after 3 seconds
                        onClose: () => {
                            notificationFlags.enableLocation = false;
                        },
                    });
                    notificationFlags.enableLocation = true;
                }
                return { error };
            }
            // Optionally handle other error codes
            console.error("Geolocation error:", error);
        }
    } else {
        console.error("Geolocation is not available in this browser.");
    }
};

// Export the function
export default userLocationRetrieve;
